const USE_THEO_PLAYER_V2_KEY = "useTHEOplayerV2";

/**
 * legacy/packages/portal/public/index.htmlの関数と処理内容は同じなので、
 * ここの関数を変更する場合には、legacy/packages/portal/public/index.htmlの関数も変更すること
 */
export const getUseTHEOplayerV2FromLocalStorage = (): boolean => {
  try {
    const useTHEOplayerV2 = localStorage.getItem(USE_THEO_PLAYER_V2_KEY);
    if (useTHEOplayerV2 === null) {
      return false;
    }
    const parsed: unknown = JSON.parse(useTHEOplayerV2);

    if (!parsed || typeof parsed !== "object" || parsed === null) {
      return false;
    }

    const parsedObj = parsed;

    if (
      !("expiredAt" in parsedObj) ||
      typeof parsedObj.expiredAt !== "number"
    ) {
      return false;
    }

    const currentTime = new Date().getTime();

    if (parsedObj.expiredAt < currentTime) {
      return false;
    }

    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};

/**
 * localStorageにTHEOplayerV2を使う設定を保存する
 * エラーが発生してから、1日間有効
 */
export const setUseTHEOplayerV2ToLocalStorage = (): void => {
  try {
    const currentTime = new Date().getTime();
    const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
    const expiredAt = currentTime + ONE_DAY_IN_MILLISECONDS;

    const useTHEOplayerV2 = {
      expiredAt,
    };

    localStorage.setItem(
      USE_THEO_PLAYER_V2_KEY,
      JSON.stringify(useTHEOplayerV2)
    );
  } catch (e) {
    console.error(e);
  }
};
